// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-small-card/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { CircleQuestionMarkIcon as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetSmallCardMeta: TWidgetMetaInfo = {
  name: 'Small Card Sample',
  categories: ['Widget'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'A small-card widget sample.',
  externalDependencies: [],
}
